import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { RouterToUrlQuery } from 'react-url-query';
import { injectGlobal, ThemeProvider } from 'styled-components';
import { customMuiTheme } from 'styles/theme/variables';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import AppRoutes from 'AppRoutes';

import loginUser from 'helpers/loginUser';

import base from 'styles/global/base';
import fonts from 'styles/global/fonts';
import hopscotch from 'styles/global/hopscotch';
import typography from 'styles/global/typography';
import colors from 'styles/theme/colors';
import variables from 'styles/theme/variables';

const DEMO_USERNAME = 'demo@democompany';
const DEMO_PASSWORD = 'k33nc0rp';

injectGlobal`
  ${base}
  ${fonts}
  ${typography}
  ${hopscotch}
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
    };

    this.handleLogin();
  }

  handleLogin = async () => {
    const response = await loginUser({
      credentials: {
        username: DEMO_USERNAME,
        password: DEMO_PASSWORD,
      },
    });

    // Update state based on the response of an user login
    this.setState({
      isAuthenticated: response.success,
      error: response.error,
      payload: response.payload,
    });
  }

  render() {
    return (
      <Router>
        <RouterToUrlQuery>
          <MuiThemeProvider theme={createMuiTheme(customMuiTheme)}>
            <ThemeProvider theme={{ ...colors, ...variables }}>
              { this.state.isAuthenticated &&
                <Route component={AppRoutes}  />
              }
            </ThemeProvider>
          </MuiThemeProvider>
        </RouterToUrlQuery>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js